import { Module } from '@nestjs/common';
import { ReasonsController } from './reasons.controller';
import { ReasonsService } from './reasons.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Reasons } from './reasons.entity';
import { ReasonsAdapter } from './dto/reasons.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';


@Module({
  imports:[
    TypeOrmModule.forFeature([Reasons]),
  ],
  controllers: [ReasonsController],
  providers: [ReasonsService,ReasonsAdapter, ApplicationExceptionHandler,LogsService]
})
export class ReasonsModule {}
